import { initializeApp } from 'firebase/app';
import { getAuth } from 'firebase/auth';
import { getFirestore } from 'firebase/firestore';

const firebaseConfig = {
    apiKey: "AIzaSyCUqzWQKyLm-IFFwXXx6uKhpxqfJJZoQbw",
    authDomain: "dmslide-55665.firebaseapp.com",
    projectId: "dmslide-55665",
    storageBucket: "dmslide-55665.firebasestorage.app",
    messagingSenderId: "80032453081",
    appId: "1:80032453081:web:ba158fd97b9e02a84689c8",
    measurementId: "G-X2HYDH89L5"
};

const app = initializeApp(firebaseConfig);
export const auth = getAuth(app);
export const db = getFirestore(app);

export default app;
